import { useState } from 'react'
import StoryMediaError from './StoryMediaError'
import type { StoryPictureMedia } from './storyMedia'

export interface StoryPictureElementProps {
	media: StoryPictureMedia
	onLoadingChange?: (loading: boolean) => void
}

export default function StoryPictureElement({ media, onLoadingChange }: StoryPictureElementProps) {
	const [loadFailed, setLoadFailed] = useState(false)
	const [reloadKey, setReloadKey] = useState(0)
	const errorMessage = media.errorMessage ?? (loadFailed ? '这张图片暂时无法显示' : undefined)

	const handleLoad = () => {
		setLoadFailed(false)
		onLoadingChange?.(false)
	}

	const handleError = () => {
		setLoadFailed(true)
		onLoadingChange?.(false)
	}

	const handleRetry = () => {
		setLoadFailed(false)
		onLoadingChange?.(true)
		setReloadKey((key) => key + 1)
	}

	return (
		<>
			{media.url && (
				<img
					key={reloadKey}
					src={media.url}
					alt={media.alt}
					referrerPolicy="no-referrer"
					draggable={false}
					onLoad={handleLoad}
					onError={handleError}
				/>
			)}
			{errorMessage && <StoryMediaError message={errorMessage} onRetry={handleRetry} />}
		</>
	)
}
